<template>
  <div>
    <v-dialog v-model="dialog" persistent max-width="500px">
      <v-card>
        <ModelTitle title="Classroom Report Card" @close="close" />
        <v-card-text>
          <v-select
            v-model="selectedYear"
            :items="years"
            item-text="name"
            return-object
            outlined
            dense
            label="Select Year"
          />
        </v-card-text>
        <v-divider />
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="primary"
            :disabled="!selectedYear"
            :loading="loading"
            @click="generate"
          >
            Generate Report Cards
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="showPdf"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
    >
      <v-card class="d-flex flex-column" style="height: 100vh">
        <v-toolbar flat>
          <v-toolbar-title>Classroom Report Cards</v-toolbar-title>
          <v-spacer />
          <v-btn icon @click="close">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>

        <embed :src="pdf" type="application/pdf" width="100%" height="100%" />
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import pdfMake from "pdfmake/build/pdfmake.min";
import { pdfMake as pdfFonts } from "pdfmake/build/vfs_fonts";
import yearService from "@/modules/ReportCard/Year/service";
import studentService from "@/modules/Student/service";
// import gradeService from "@/modules/ReportCard/Grades/service";
// import termService from "@/modules/ReportCard/Terms/service";
// import subjectService from "@/modules/ReportCard/Subject/service";
import { buildStudentReportCard } from "@/modules/ClassRoom/components/buildStudentReportCard.js";

pdfMake.vfs = pdfFonts.vfs;

export default {
  name: "classroom-report-card",
  props: {
    ClassRoom: Object, // selected classroom
  },

  data() {
    return {
      dialog: true,
      loading: false,
      showPdf: false,
      pdf: null,
      years: [],
      selectedYear: null,
      students: [],
      doc: {
        pageSize: "LETTER",
        pageOrientation: "portrait",
        pageMargins: [40, 30, 40, 30],
        content: [],
      },
    };
  },

  mounted() {
    this.getYears();
  },

  methods: {
    close() {
      this.dialog = false;
      this.showPdf = false;
      this.$emit("close");
    },

    async getYears() {
      const res = await yearService.getAll({
        filteredClasses: [this.ClassRoom.ClassId],
      });
      this.years = res.data;
    },

    async generate() {
      this.loading = true;

      this.doc = {
        pageSize: "LETTER",
        pageOrientation: "portrait",
        pageMargins: [40, 30, 40, 30],
        content: [],
      };

      await this.getStudents();

      for (let i = 0; i < this.students.length; i++) {
        const page = await this.buildStudentReport(this.students[i]);
        this.doc.content.push(...page);

        if (i < this.students.length - 1) {
          this.doc.content.push({ text: "", pageBreak: "after" });
        }
      }

      pdfMake.createPdf(this.doc).getBlob((blob) => {
        this.pdf = URL.createObjectURL(blob);
        this.showPdf = true;
        this.dialog = false;
        this.loading = false;
      });
    },

    async getStudents() {
      const res = await studentService.getStudentByClassRoomId({
        ClassRoomId: this.ClassRoom.id,
      });
      this.students = res.data;
    },
    async buildStudentReport(student) {
      return await buildStudentReportCard({
        student,
        classroom: this.ClassRoom,
        year: this.selectedYear,
        currentBusiness: this.$store.getters["global/currentBusiness"],
      });
    },
  },
};
</script>
